import { IResult, Nullable } from './type';
import { baseUrl } from './url';
export interface IUser {
  id: number;
  contextId: number;
  firstName: string;
  lastName: string;
  token: string;
  localAdmin: boolean;
}
export const USER_KEY = 'user';

const getUser = (): Nullable<IUser> => {
  const raw = window.sessionStorage.getItem(USER_KEY);
  let user;
  if (raw) {
    user = JSON.parse(raw) as IUser;
  }
  // console.log(user?.token);
  return user || null;
};

const getNonNullUser = (): IUser => {
  const user = getUser();
  if (!user) {
    throw new Error('Unable to find user');
  }
  return user;
};

const login = async (
  userName: string,
  password: string,
  businessContext?: number,
  allowNonAdmin?: boolean
): Promise<IResult<IUser>> => {
  try {
    console.log('Loging in');
    const response = await fetch(`${baseUrl}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userName,
        password
      })
    });
    if (!response.ok) {
      return {
        error: 'Invalid credentials'
      };
    }
    const { user, context } = await response.json();

    if (businessContext && context.id !== businessContext) {
      return {
        error: 'Invalid Business'
      };
    }

    const value = {
      id: user.id,
      contextId: context.id,
      firstName: user.firstName,
      lastName: user.lastName,
      token: user.guid,
      localAdmin: user.localAdmin
    };

    if (!allowNonAdmin && !value.localAdmin) {
      return {
        error: 'Not an admin'
      };
    }

    window.sessionStorage.setItem(USER_KEY, JSON.stringify(value));
    console.log(window.sessionStorage.getItem(USER_KEY));
    return {
      value
    };
  } catch (ex) {
    return {
      error: 'Unable to connect to server'
    };
  }
};

const logout = () => {
  window.sessionStorage.clear();
  window.location.reload();
};
export { getUser, login, getNonNullUser, logout };
